module.exports = __webpack_public_path__ + "img/introducePage_show_five.a460db2f.jpg";